import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const artifactRegistryAppBuilder = DataRouterApplicationBuilder.create('artifact-registry')
